/*jshint esversion: 6 */
/*jshint sub:true*/
import { mapGetters} from 'vuex';
export const AppNavigationMixin = {
  computed: {
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex',
    ]),
  },
  methods: {
  }
};
